import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Field, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui/spinner";
import CapiTestEventResult from "routes/meta_leads/CapiTestEventResult";
import MetaDatasetService from "services/MetaDataset";

const StandaloneDatasetHealthCheckCard = ({ datasetPk }) => {
  const [testEventCode, setTestEventCode] = useState("");
  const [result, setResult] = useState(null);

  const mutation = useMutation({
    mutationFn: () =>
      MetaDatasetService.sendStandaloneTestEvent(datasetPk, testEventCode),
    onSuccess: response => setResult({ ok: true, body: response }),
    onError: err =>
      setResult({
        ok: false,
        body: err.response?.data ?? err.body ?? { message: String(err) },
      }),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Conversions API health check</CardTitle>
        <CardDescription>
          Send a single synthetic event to this dataset with its saved access
          token, to confirm that the dataset id and the token work together.
          Paste the test event code from the Events Manager Test Events tab; the
          event appears there. Meta does not drop events sent with a test event
          code.
        </CardDescription>
      </CardHeader>
      <CardContent className="tw:flex tw:flex-col tw:gap-4">
        <Field className="tw:w-80">
          <FieldLabel htmlFor="standalone-dataset-test-event-code">
            Test event code
          </FieldLabel>
          <Input
            id="standalone-dataset-test-event-code"
            value={testEventCode}
            onChange={event => setTestEventCode(event.target.value)}
            placeholder="TEST12345"
          />
        </Field>

        <div>
          <Button
            onClick={() => mutation.mutate()}
            disabled={!testEventCode || mutation.isPending}
          >
            {mutation.isPending && <Spinner />}
            Send test event
          </Button>
        </div>

        {result && <CapiTestEventResult result={result} />}
      </CardContent>
    </Card>
  );
};

export default StandaloneDatasetHealthCheckCard;
